import { defineMessages, useIntl } from 'react-intl';
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import AdvancedHotkey from './component';

export const messages = defineMessages({
  name: {
    description: 'navigationHotkeys.AccountSettingsPage',
    defaultMessage: 'Account Settings',
    id: 'eOmpG2',
  },
});

export const hotkey = ['g', 'a', 'm'];
export const barcodeContent = '+YXPQYR66NJSN=';

const GotoAccountSettingsPage = ({ children }) => {
  const intl = useIntl();
  const history = useHistory();
  const handler = useCallback(() => history.push('/settings'), [history]);
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: ['gam'],
      hotkey,
      handler,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'navigation',
      isGlobal: true,
    }),
    [intl, handler],
  );

  return <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>;
};

GotoAccountSettingsPage.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GotoAccountSettingsPage;
